import axiosInstance from '../axiosInstance';

const API_BASE = '/api3.2/cancam';

export interface CANCamVideo {
    VideoID: string;
    DeviceID: string;
    BucketFileID: string | null;
    CommentListID: number | null;
    EndpointID: number | null;
    FileName: string;
    Duration: number | null;
    FileSizeBytes: number | null;
    RecordedAt: string | null;
    UploadedAt: string;
    GPS_Latitude: number | null;
    GPS_Longitude: number | null;
}

export interface GetVideosByPatrolResponse {
    videos: CANCamVideo[];
}

/**
 * Get CANcam videos associated with a patrol (by comment_list_id)
 */
export async function getVideosByPatrol(commentListId: number): Promise<CANCamVideo[]> {
    const { data } = await axiosInstance.get<GetVideosByPatrolResponse>(
        `${API_BASE}/patrol/${commentListId}/videos`
    );
    return data.videos;
}

/**
 * Get video stream URL for playback
 */
export function getVideoStreamUrl(videoId: string): string {
    return `${API_BASE}/videos/${videoId}/stream`;
}

/**
 * Get video details by ID
 */
export async function getVideoById(videoId: string): Promise<CANCamVideo | null> {
    try {
        const { data } = await axiosInstance.get<CANCamVideo>(
            `${API_BASE}/videos/${videoId}`
        );
        return data;
    } catch {
        return null;
    }
}
